export const NAV = {
  root: "site-nav",
  logo: "site-nav-logo",
  linkHome: "site-nav-link-home",
  linkShop: "site-nav-link-shop",
  linkAbout: "site-nav-link-about",
  linkProducts: "site-nav-link-products",
  linkGallery: "site-nav-link-gallery",
  linkContact: "site-nav-link-contact",
  ctaQuote: "site-nav-cta-quote",
  menuToggle: "site-nav-menu-toggle",
  cartButton: "site-nav-cart-button",
  cartCount: "site-nav-cart-count",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  scrollHint: "hero-scroll-hint",
  ctaQuote: "hero-cta-quote",
  ctaExplore: "hero-cta-explore",
};

export const MARQUEE = { root: "marquee-section" };

export const ANNOUNCE = { root: "announcement-bar", track: "announcement-track" };

export const SHOP_BY_CAT = {
  root: "shop-by-category",
  card: (slug) => `shop-cat-${slug}`,
};

export const FEAT_COLLECTIONS = {
  root: "featured-collections",
  card: (slug) => `feat-collection-${slug}`,
};

export const CUSTOM_CURTAINS = { root: "custom-curtains" };
export const BEDSPREADS_BLOCK = { root: "bedspreads-block" };
export const ROUND_BEDDING = { root: "round-bedding", card: (slug) => `round-card-${slug}` };
export const INSTAGRAM = { root: "instagram-feed", item: (i) => `insta-item-${i}` };

export const MANIFESTO = {
  root: "manifesto-section",
  chapter: (i) => `manifesto-chapter-${i}`,
};

export const PRODUCTS = {
  root: "products-section",
  filter: (slug) => `products-filter-${slug}`,
  card: (slug) => `products-card-${slug}`,
};

export const WHYUS = { root: "whyus-section", item: (i) => `whyus-item-${i}` };

export const GALLERY = { root: "gallery-section", image: (i) => `gallery-image-${i}` };

export const TESTIMONIALS = { root: "testimonials-section", card: (i) => `testimonial-${i}` };
export const REVIEWS_TIDS = { root: "reviews-section", card: (i) => `review-card-${i}` };

export const INQUIRY = {
  root: "inquiry-section",
  form: "inquiry-form",
  name: "inquiry-name",
  company: "inquiry-company",
  phone: "inquiry-phone",
  email: "inquiry-email",
  product: "inquiry-product",
  quantity: "inquiry-quantity",
  message: "inquiry-message",
  submit: "inquiry-submit",
};

export const CONTACT = {
  root: "contact-section",
  phone: "contact-phone",
  whatsapp: "contact-whatsapp",
  email: "contact-email",
  map: "contact-map",
};

export const FLOATING = {
  whatsapp: "floating-whatsapp",
  call: "floating-call",
};

export const FOOTER = {
  root: "site-footer",
  social: (name) => `footer-social-${name}`,
};

// Storefront
export const SHOP = {
  root: "shop-page",
  filter: (slug) => `shop-filter-${slug}`,
  card: (slug) => `shop-card-${slug}`,
  sort: "shop-sort",
};

export const PDP = {
  root: "product-page",
  title: "pdp-title",
  price: "pdp-price",
  size: (v) => `pdp-size-${v}`,
  colour: (name) => `pdp-colour-${name}`,
  qtyMinus: "pdp-qty-minus",
  qtyPlus: "pdp-qty-plus",
  qtyValue: "pdp-qty-value",
  addToCart: "pdp-add-to-cart",
  whatsappOrder: "pdp-whatsapp-order",
  thumb: (i) => `pdp-thumb-${i}`,
};

export const CART = {
  drawer: "cart-drawer",
  close: "cart-close",
  item: (slug) => `cart-item-${slug}`,
  itemQtyPlus: (slug) => `cart-item-plus-${slug}`,
  itemQtyMinus: (slug) => `cart-item-minus-${slug}`,
  itemRemove: (slug) => `cart-item-remove-${slug}`,
  subtotal: "cart-subtotal",
  checkout: "cart-checkout-whatsapp",
  empty: "cart-empty",
};
